import { createFileRoute } from "@tanstack/react-router";
import { Generate } from "@/features/generate";

export const Route = createFileRoute("/_authenticated/generate/")({
  component: Generate,
});
